import { User } from "./user";

export interface Organization{
  id: number,
  name: string,
  domain: string,
  inviteCode: string,
  members?: OrganizationUser[],
  createdAt: Date,
  updatedAt: Date,
  deleteAt:Date,
}

export interface OrganizationUser{
  id: number, 
  organizationId: number
  userId: number,
  role: IRoleOrganizationUser,
  status: number,
  invitedById: number,
  invitedEmail?: string,
  user: User,
  organization: Organization,
  invitedBy: User,
  isOwner?: boolean,
  createdAt: Date,
  updatedAt: Date,
  deleteAt:Date,
}

export enum IRoleOrganizationUser {
  ADMIN = 1,
  MEMBER = 2,
}

export enum IStatusOrganizationUser {
  PENDDING = 1,
  APPROVED = 2,
  REJECTED = 3,
}